var render = function render(){var _vm=this,_c=_vm._self._c;return (this.me)?_c('div',[_c('h1',[_vm._v("\n    "+_vm._s(_vm.me.email)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }